import { useCallAction, useEvent } from "@cobuildlab/react-simple-state";
import { fetchCommentUrlEvent } from "../comment-events";
import { fetchCommentURL } from "../comment-actions";
import { useEffect, useState } from "react";
import { PostComment } from "../comment-types";
import { FRONT_URL } from "../../../shared/constants";

export const CommentPostUrl:React.FC<{post_id:number}> = ({post_id}) => {
    //const { comments } = useEvent(fetchCommentUrlEvent);
    const [comments, setComments] = useState<PostComment[] | undefined>(undefined);
    const [loading, setLoading] = useState<boolean>();
    const [callComments] = useCallAction(fetchCommentURL,{
        onCompleted:(res)=>{
            setComments(res.comments);
            setLoading(false);
        },
        onError:()=>{
            console.log('Error al traer el url');
        }
    });
    useEffect(()=>{
        if(comments?.[0]?.databaseId === post_id){
            window.open(FRONT_URL+ (comments?.[0]?.post_url || ''), '_blank');
        }
    },[comments]);
    if(loading){
        return(
            <div>
                Cargando...
            </div>
        )
    }
    return(
        <div onClick={()=>{
            callComments(post_id);
            setLoading(true);
        }}>
            Ir a la nota {'->'}
        </div>
    );
};